// WebRTCManager.js (conceptual changes - ensure these are implemented in your file)

let janusInstance = null;
let audioPluginHandle = null;
let localMediaStream = null; // To store the local stream
const remoteMediaStreams = new Map(); // To store multiple remote streams (keyed by participant ID or track ID)

export const setJanusInstance = (instance) => {
    janusInstance = instance;
};

export const getJanusInstance = () => {
    return janusInstance;
};

export const setAudioPluginHandle = (handle) => {
    audioPluginHandle = handle;
};

export const getAudioPluginHandle = () => {
    return audioPluginHandle;
};

// --- NEW FUNCTIONS TO ADD ---

export const setLocalMediaStream = (stream) => {
    localMediaStream = stream;
    console.log("WebRTCManager: Local MediaStream set:", stream);
};

export const getLocalMediaStream = () => {
    return localMediaStream;
};

export const addRemoteMediaStream = (id, stream) => {
    // 'id' could be the participant's unique ID, or track ID for multi-track scenarios
    remoteMediaStreams.set(id, stream);
    console.log("WebRTCManager: Remote MediaStream added:", id, stream);
};

export const getRemoteMediaStream = (id) => {
    return remoteMediaStreams.get(id);
};

export const getAllRemoteMediaStreams = () => {
    return Array.from(remoteMediaStreams.values());
};

export const removeRemoteMediaStream = (id) => {
    remoteMediaStreams.delete(id);
    console.log("WebRTCManager: Remote MediaStream removed:", id);
};